var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "cell-prize",
      class: {
        "cell-prize-green": _vm.record.prize.value > 0,
        "cell-prize_disabled": !_vm.canEdit,
      },
      on: {
        click: function ($event) {
          _vm.canEdit &&
            (_vm.calculateType === "byPeriod"
              ? (_vm.isShowPremiumPeriodModal = true)
              : (_vm.isShowPremiumPeriodModal = true))
        },
      },
    },
    [
      _vm.calculateType === "byPeriod"
        ? _c("m-show-premium-period-modal", {
            attrs: {
              active: _vm.isShowPremiumPeriodModal,
              record: _vm.record,
              "calc-data": _vm.calculationData,
            },
            on: {
              close: function ($event) {
                _vm.isShowPremiumPeriodModal = false
              },
              updateBonuses: _vm.updateBonuses,
            },
          })
        : _vm._e(),
      _vm.calculateType === "byDate"
        ? _c("m-show-premium-period-modal", {
            attrs: {
              active: _vm.isShowPremiumPeriodModal,
              record: _vm.record,
              "calc-data": _vm.calculationData,
            },
            on: {
              close: function ($event) {
                _vm.isShowPremiumPeriodModal = false
              },
              updateBonuses: _vm.updateBonuses,
            },
          })
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "cell-prize-value",
          class: {
            "cell-prize-value-grey": _vm.record.prize.value.toString() === "0",
          },
        },
        [_vm._v(" " + _vm._s(_vm.record.prize.value) + " ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }